<template>
	<div class="add-box">
		<el-dialog v-model="dialogVisible"  :title="title" width="500px" :before-close="handleClose">
			<div style="max-width: 450px; height: 640px;">
				<img :src="picPath" style="height: 100%; width:100%; object-fit:cover;">
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: ['titleValue',"pathPic"],
		components: {},
		data() {
			return {
				dialogVisible: true,
				picPath: "",
				title:''
			};
		},
		created() {
			this.title = this.titleValue
			this.picPath = this.pathPic
		},
		mounted() {},
		methods: {
			handleClose() {
				this.$emit('addClick')
			},

			selectFile(event) {
				this.$refs.fileInput.click();
			},
		},
	};
</script>

<style scoped lang="scss">
	/deep/ {
		.el-dialog__body {
			// height: 75%;
			max-height: 500px;
			// min-height: 350px;        
			overflow: auto;
		}

		// }
		.el-input--small {
			width: 250px;
		}

		.el-select .el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-form-item--small .el-form-item__label {
			height: 35px;
			line-height: 35px;
		}

		.el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-radio.el-radio--small .el-radio__inner {
			width: 14px;
			height: 14px;
		}

		.el-input__wrapper {
			height: 35px;
			line-height: 35px;
		}

		.el-date-editor.el-input,
		.el-date-editor.el-input__wrapper {
			height: 35px !important;
		}

		.el-select--small .el-select__wrapper {
			width: 250px;
			height: 35px;
		}
	}
</style>